import React, { useState } from 'react';

const AmountQueryModal = ({ showModal, onClose, onQuery }) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [queryType, setQueryType] = useState('paid');
    const [queryResult, setQueryResult] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleQuery = async () => {
        setLoading(true);
        const result = await onQuery(startDate, endDate, queryType);
        setQueryResult(result ?? 0);
        setLoading(false);
    };

    if (!showModal) {
        return null;
    }

    return (
        <div className="modal show" tabIndex="-1" style={{ display: 'block' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Query Amount</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label>Start Date:</label>
                            <input
                                type="date"
                                className="form-control"
                                value={startDate}
                                onChange={e => { setStartDate(e.target.value); setQueryResult(null); }}
                            />
                        </div>
                        <div className="form-group mt-2">
                            <label>End Date:</label>
                            <input
                                type="date"
                                className="form-control"
                                value={endDate}
                                onChange={e => { setEndDate(e.target.value); setQueryResult(null); }}
                            />
                        </div>
                        <div className="form-group mt-2">
                            <label>Type:</label>
                            <select
                                className="form-control"
                                value={queryType}
                                onChange={e => { setQueryType(e.target.value); setQueryResult(null); }}
                            >
                                <option value="paid">Paid</option>
                                <option value="taught">Taught</option>
                            </select>
                        </div>
                        {queryResult !== null && (
                            <div className="mt-3">
                                <h5>Total Amount: ${queryResult}</h5>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleQuery}
                            disabled={loading || !startDate || !endDate}
                        >
                            {loading ? 'Querying...' : 'Query'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AmountQueryModal;
